import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { uploadedByOptions } from 'modules/FileManagerV2/constants/fileManagerConstants';

function UploadedByFilter() {
  const { fileManagerFilters, setSelectedRows, setFileManagerFilters } = useFileManagerContext();

  const handleUploadedByChange = (e) => {
    const selectedValue = e.value;

    // Update filters in one atomic operation to avoid double API calls
    setFileManagerFilters((prevValues) => {
      const newFilters = {
        ...prevValues,
        uploadedBy: selectedValue,
      };

      if (selectedValue === 'client') {
        // Client Uploads selected - set is_client_uploaded to true, no case_id
        newFilters.is_client_uploaded = true;
        newFilters.forceCaseUndefined = false;
      } else if (selectedValue === 'firm') {
        // Firm Uploads selected - don't send is_client_uploaded, send case_id as undefined
        newFilters.is_client_uploaded = '';
        newFilters.forceCaseUndefined = false;
        newFilters.isFirmUploads = true;
      } else {
        // All Uploads selected - don't send is_client_uploaded, don't include case_id at all
        newFilters.is_client_uploaded = '';
        newFilters.forceCaseUndefined = false;
        newFilters.isFirmUploads = false;
      }

      return newFilters;
    });

    setSelectedRows([]);
  };

  return (
    <Dropdown
      options={uploadedByOptions}
      value={fileManagerFilters?.uploadedBy}
      placeholder="All Uploads"
      className="file-manager-select w-100"
      onChange={handleUploadedByChange}
      name="uploadedBy"
    />
  );
}

export default UploadedByFilter;
